import { render, staticRenderFns } from "./DominioListAddNew.vue?vue&type=template&id=ab591e1c&"
import script from "./DominioListAddNew.vue?vue&type=script&lang=js&"
export * from "./DominioListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./DominioListAddNew.vue?vue&type=style&index=0&id=ab591e1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports